<template>
<div>
    <div class="d-flex justify-space-between mb-2">
        <div class="d-flex justify-center align-center">
            <div class="img_title_bill_retrospect">
                <img src="@/assets/icon-restaurant-close-restaurant.png">
            </div>
            <h2 class="title_bill_retrospect">รายการปิดร้านย้อนหลัง</h2>
        </div>

        <v-btn class="grad-primary-bg white--text titlefont_bill_retrospect" height="50" width="20%" @click="$router.push('/restaurant')">
            ย้อนกลับ
        </v-btn>
    </div>


    <v-card>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div v-if="loading_page === false">
            <v-card-title>
                <v-text-field v-model="search" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <div>
                <v-data-table :headers="headers" :items="data" :search="search">
                    <template v-slot:item="dataDetail">
                        <tr>
                            <td>{{dataDetail.item.created_at}}</td>
                            <td>{{dataDetail.item.restaurant_close_time}}</td>
                            <td>{{dataDetail.item.price_total}}</td>
                            <td>{{dataDetail.item.price_delivery_total}}</td>
                            <td :class="dataDetail.item.status == 'ปิดร้านด้วยตนเอง' ? 'success--text' : dataDetail.item.status == 'ปิดร้านอัตโนมัติ' ? 'warning--text' : ''">{{dataDetail.item.status}}</td>
                            <td>
                                <span class="detail_bill_retrospect" @click="detailCloseRetrospect(dataDetail.item.id)">
                                    <v-icon right color="grey">mdi-pencil-box-outline</v-icon>
                                </span>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </div>
            
        </div>
    </v-card>
    
    
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
export default {
    name: 'closeRetrospectall',
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: false,
            search: '',
            headers: [{
                    text: 'วันที่',
                    align: 'date',
                    value: 'created_at',
                },
                {
                    text: 'เวลาปิดร้าน',
                    value: 'restaurant_close_time'
                },
                {
                    text: 'ยอดขายหน้าร้าน',
                    value: 'price_total'
                },
                {
                    text: 'ยอดขายเดลิเวอร์รี่',
                    value: 'price_delivery_total'
                },
                {
                    text: 'สถานะ',
                    value: 'status'
                },
                {
                    text: 'ดูรายละเอียด',
                    value: 'action'
                },
            ],
            data: [],
        }
    },
    methods: {
        async closeRetrospectList() {
            this.loading_page = true
            this.data = []
            HTTP.get('/listCloseStore', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        response.data.list.forEach(detail => {
                            let status = null
                            if (detail.status == 0) {
                                status = 'ปิดร้านด้วยตนเอง'
                            }
                            if (detail.status == 1) {
                                status = 'ปิดร้านอัตโนมัติ'
                            }
                            if (detail.status == null) {
                                status = '-'
                            }
                            this.data.push({
                                id:detail.id,
                                created_at:detail.created_at,
                                restaurant_close_time:detail.restaurant_close_time,
                                price_total:detail.price_total,
                                price_delivery_total:detail.price_delivery_total,
                                status:status,
                            })
                        })
                        this.loading_page = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async detailCloseRetrospect(id){
            const idPage = {
                id:id
            }
            this.$store.commit('detailCloseRetrospectPage',idPage)
            this.$router.push('/closeretrospectdetail')
        }
    },

    mounted(){
        this.closeRetrospectList()
    }

}
</script>
